import homeRouter from './home-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/dashboard',
    component: () => import('@/view/home/home'),
    children: [...homeRouter],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/view/login/login'),
  },
  {
    path: '/login/verify-key',
    name: 'LoginVerifyKey',
    component: () => import('@/view/login/blockchain-verify'),
    meta: { title: '区块链安全验证' },
  },
  {
    path: '/sign',
    name: 'ContractSignMobile',
    component: () => import('@/view/business/smart-contract/sign-mobile.vue'),
    meta: { title: '合同签署', public: true },
  },
  {
    redirect: '/404',
    path: '/:pathMatch(.*)',
  },
]

export default routes
